import React from "react";
import Alert from "../Alert/Alert";
import {
  restrainingOrders,
  advertisingOrders,
} from "../../utils/nopOverrides";
import { FaFilePdf } from "react-icons/fa";

const NOPtable = ({ id, nops, insolvency, ...props }) => {
  
  const filterOrders = (actions) => nops && nops.filter(item => actions.includes(item.OBD_HEADER_VALUE));
  const ordersExist = (orders) => orders && orders.length > 0 ? orders : false;

  const refuseOrders = ordersExist(filterOrders(["NOTICE TO REFUSE"]));
  const freezeOrders = ordersExist(filterOrders(["FREEZE ORDER"]));
  const revokeOrders = ordersExist(filterOrders(["NOTICE TO REVOKE"]));
  const adminPenalties = ordersExist(filterOrders(["ADMINISTRATIVE PENALTY"]));
  const complianceOrders = ordersExist(filterOrders(["COMPLIANCE ORDER"]));
  const conditionsOrders = ordersExist(filterOrders(["NOTICE OF CONDITIONS"]));
  const suspensionOrders = ordersExist(filterOrders(["SUSPENSION ORDER"]));

  const formatDate = (dbdate) => {
    if (!dbdate) return "N/A";
    // Parse the ISO string and extract date part only to avoid timezone shift
    const dateStr = dbdate.split('T')[0]; // Gets "2025-11-20"
    const [year, month, day] = dateStr.split('-');
    const date = new Date(year, month - 1, day); // Create date in local timezone
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  };

  // Add one day to the date and return formatted date
  const addOneDayAndFormat = (dbdate) => {
    if (!dbdate) return "N/A";
    // Parse the ISO string and extract date part, then add one day
    const dateStr = dbdate.split('T')[0]; // Gets "2025-11-20"
    const [year, month, day] = dateStr.split('-');
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + 1);
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  };

  const renderOrdersTable = (orders, title) => (
    <>
      <h4>{title}</h4>
      <table style={{ marginBottom: `2rem` }}>
        <thead>
          <tr>
            <th>Details</th>
            <th>Date Issued</th>
            {title === "Compliance Order" && <th>Compliance Status</th>}
          </tr>
        </thead>
        <tbody>
          {orders.map((order, i) => (
            <tr key={`${id}_${i}`}>
              <td>
                <a
                  href={order.SHAREPOINT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFilePdf
                    style={{
                      fontSize: `1.5rem`,
                      marginRight: `.5rem`,
                    }}
                  />
                  <span>{order.DOCUMENT_NAME || order.ACTION_VALUE || order.OBD_HEADER_VALUE || "(PDF)"}</span>
                </a>
              </td>
              <td>{order.DATE_ISSUED ? formatDate(order.DATE_ISSUED) : "N/A"}</td>
              {order.OBD_HEADER_VALUE === "COMPLIANCE ORDER" && (
                <td>{ order.VB_IN_COMPLIANCE === "true" ? "In Compliance": "Not In Compliance"}</td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      
      {Array.isArray(orders) && orders[0].OBD_HEADER_VALUE === "COMPLIANCE ORDER" && orders.every(o => o?.VB_IN_COMPLIANCE === "true") && (
        <Alert type="success">
          NOTE: This vendor and/or builder has since come into compliance.
        </Alert>
      )}
      
      {/* {orders[0].ACTION_VALUE && (
          <Alert type="success">
            {orders[0].ACTION_VALUE}
          </Alert>
        )} */}
    </>
  );

  return (
    <>
      {!complianceOrders &&
        !conditionsOrders &&
        !revokeOrders &&
        !refuseOrders &&
        !freezeOrders &&
        !suspensionOrders &&
        !insolvency?.length > 0 &&
        !restrainingOrders[id] &&
        !advertisingOrders[id] &&
        !adminPenalties && (
          <Alert type="success">
            This builder has not been issued any registrar notices or orders.
          </Alert>
        )}

      {adminPenalties && renderOrdersTable(adminPenalties, "Administrative Penalty")}
      {revokeOrders && renderOrdersTable(revokeOrders, "Notice to Revoke")}
      {refuseOrders && renderOrdersTable(refuseOrders, "Notice to Refuse")}
      {freezeOrders && renderOrdersTable(freezeOrders, "Freeze Order")}
      {complianceOrders && renderOrdersTable(complianceOrders, "Compliance Order")}
      {conditionsOrders && renderOrdersTable(conditionsOrders, "Notice of Conditions")}
      {suspensionOrders && renderOrdersTable(suspensionOrders, "Suspension Order")}

      {insolvency?.length > 0 && (
        <>
          <h4>Insolvency</h4>
          {insolvency[0].OBD_BANNER_POSTED === "Yes" && (
            <table style={{ marginBottom: `2rem` }}>
              <thead>
                <tr>
                  <th>Details</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {insolvency.map((order, i) => (
                  <tr key={`${i}`}>
                    <td>
                      <a
                        href={`${order.DOC_SHAREPOINT_URL}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFilePdf
                          style={{
                            fontSize: `1.5rem`,
                            marginRight: `.5rem`,
                          }}
                        />
                        <span>{order.DOCUMENT_NAME || order.INSOLVENCY_PROCEEDING_TYPE || "(PDF)"}</span>
                      </a>
                    </td>
                    <td>{order.DECISION_DATE ? addOneDayAndFormat(order.DECISION_DATE) : "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}

      {advertisingOrders[id] ? (
        <>
          <h4>Advertising Order</h4>
          {advertisingOrders[id][0].title && (
            <table style={{ marginBottom: `2rem` }}>
              <thead>
                <tr>
                  <th>Details</th>
                  <th>Date Issued</th>
                </tr>
              </thead>
              <tbody>
                {advertisingOrders[id].map((order, i) => (
                  <tr key={`${id}_${i}`}>
                    <td>
                      <a
                        href={require(`../../docs/${order.doc}`)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFilePdf
                          style={{
                            fontSize: `1.5rem`,
                            marginRight: `.5rem`,
                          }}
                        />
                        <span>{order.title}</span>
                      </a>
                    </td>
                    <td>{order.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {advertisingOrders[id][0].inCompliance && (
            <Alert type="success">
              NOTE: This vendor and/or builder has since come into compliance.
            </Alert>
          )}
        </>
      ) : restrainingOrders[id] ? (
        <>
          <h4>Notice of Restraining Order</h4>
          {restrainingOrders[id][0].title && (
            <table style={{ marginBottom: `2rem` }}>
              <thead>
                <tr>
                  <th>Details</th>
                  <th>Date Issued</th>
                </tr>
              </thead>
              <tbody>
                {restrainingOrders[id].map((order, i) => (
                  <tr key={`${id}_${i}`}>
                    <td>
                      <a
                        href={require(`../../docs/${order.doc}`)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFilePdf
                          style={{
                            fontSize: `1.5rem`,
                            marginRight: `.5rem`,
                          }}
                        />
                        <span>{order.title}</span>
                      </a>
                    </td>
                    <td>{order.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      ) : (
        <>
        </>
      )}
    </>
  );
};

export default NOPtable;
